import React, { useEffect, useState } from "react";
import BaseModal from "@reusables/Modals/BaseModal";
import BaseBadge from "@reusables/BaseBadge";
import dayjs from "dayjs";
import { Changelog } from "@/types/general";
import "./changelog.sass";

type ChangelogModalProps = {
    isOpen: boolean;
    onClose: () => void;
    changelog: Changelog.Root;
}

export default function ChangelogModal({ changelog, ...props }: ChangelogModalProps) {
    const [content, setContent] = useState<string>("");

    useEffect(() => {
        if (!changelog.Content || !props.isOpen) return;

        setContent(changelog.Content);
    }, [changelog.Content, props.isOpen]);

    return (
        <BaseModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            width={865}
            padding="56px"
            useCloseIcon
        >
            <div className="space-y-[32px] changelog-modal">
                <div className={"text-center space-y-2"}>
                    <div className="text-xl font-semibold text-center text-accent">
                        {changelog.Title}
                    </div>
                    <BaseBadge
                        className={"bg-gray-50 border"}>{dayjs(changelog.publishedAt).format("MMM D")}</BaseBadge>
                </div>

                {/* Changelog content*/}
                <div className={"space-y-4 "} dangerouslySetInnerHTML={{ __html: content }} />
            </div>
        </BaseModal>
    );
}